var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "roadmap 1",
    clipPath: "url(#clip0_7105_1025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.25 11.75H4.044C3.705 11.75 3.389 11.578 3.204 11.293L0.75 7.5L3.204 3.707C3.388 3.422 3.704 3.25 4.044 3.25H10.25C11.355 3.25 12.25 4.145 12.25 5.25V9.75C12.25 10.855 11.355 11.75 10.25 11.75Z",
    stroke: "#86898E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.89453 14.4991C6.19153 15.2321 6.90953 15.7491 7.74953 15.7491H13.9555C14.2945 15.7491 14.6105 15.5771 14.7955 15.2921L17.2495 11.4991L14.7665 7.66211",
    stroke: "#86898E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7105_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapDashboard);
export default __webpack_public_path__ + "static/media/roadmap-dashboard.c1970d939319e2920d3c2bc78a33bad0.svg";
export { ForwardRef as ReactComponent };